import Divider from './Divider';
import Container from './Container';
import LeftText from './LeftText';
import DateText from './DateText';
import RightText from './RightText';
import ChevronButton from './ChevronButton';
import ResumeCard from './ResumeCard';
import InsurancePolicyInfo from './InsurancePolicyInfo';
import CancelStatus from './CancelStatus';
import Chevron from './Chevron';
import InsuranceStatus from './InsuranceStatus';

export const Components = {
  Divider,
  Container,
  LeftText,
  DateText,
  RightText,
  ChevronButton,
  ResumeCard,
  InsurancePolicyInfo,
  CancelStatus,
  Chevron,
  InsuranceStatus,
};
